var map = {
	"./18PW.png": 85223,
	"./19PW.png": 4488,
	"components/Catalog/PW/img/inserDoor/ks/ksPlusLiteGray/18PW.png": 85223,
	"components/Catalog/PW/img/inserDoor/ks/ksPlusLiteGray/19PW.png": 4488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66752;